"use strict";

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

var isIterable = require("../Strict/isIterable.js");

module.exports = reverseL;

function* reverseL(arr) {
  if (!Array.isArray(arr) && isIterable(arr)) return yield* reverseL(Array.from(arr));
  let l = arr.length;

  while (l--) yield arr[l];
}